export default class TiktokTagAnalytics {
  static async fireEvent(type, eventData, user) {
    if (user) {
      await this.fireIdentity(user.email, user.id);
    }

    await this.fireTrack(type, eventData);
  }

  static async fireIdentity(email, id) {
    await window.ttq.identify({
      email: await this.sha256(email),
      external_id: await this.sha256(id),
    });
  }

  static async fireTrack(type, eventData) {
    await window.ttq.track(type, eventData);
  }

  static async sha256(message) {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
  }

  static fireViewContent(user) {
    this.fireEvent('ViewContent', {}, user);
  }

  static fireAddToCart(user, value, currency) {
    this.fireEvent('AddToCart', { value, currency }, user);
  }

  static fireCompletePayment(user, value, currency, orderId) {
    this.fireEvent('CompletePayment', {
      contents: [
        { content_id: orderId },
      ],
      value,
      currency,
    }, user);
  }
}
